import React from 'react';
import {OrbitComponent} from "../../../../base-components/orbit-component/orbit-component";
import {observer} from "mobx-react";
import {MinimumGamblingAgeComponent} from "../../minimum-gambling-age.component";
import {
    BlankHorizontalSeparatorBox
} from "../../../../../basic-components/blank-separator/blank-horizontal-separator.box";
import {NetherlandsMinimumGamblingAgeLabelBox} from "./boxes/netherlands-minimum-gambling-age-label.box";

interface NetherlandsMinimumGamblingAgeComponentProps {
    isShownInHeader?: boolean;
}

export const NetherlandsMinimumGamblingAgeComponent = observer(class NetherlandsMinimumGamblingAgeComponent extends OrbitComponent<NetherlandsMinimumGamblingAgeComponentProps> {
    render() {
        const isShownInHeader = this.props.isShownInHeader ?? false;
        return (
            <MinimumGamblingAgeComponent isShownInHeader={isShownInHeader}>
                <BlankHorizontalSeparatorBox multiplier={0.5}/>
                <NetherlandsMinimumGamblingAgeLabelBox>
                    Speel bewust
                </NetherlandsMinimumGamblingAgeLabelBox>
            </MinimumGamblingAgeComponent>
        );
    }
});